/**
 * @module components\selfcare-raise-complaint\SelfcareRaiseComplaint
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import store from '@/store';
import { Prop, Watch } from 'vue-property-decorator';
import SelfRaiseTabHeading from '../../common-components/self-raise-tabHeading/self-raise-tabHeading.vue';
import GetCategoryListing from '../../../services/api/getCategoryListing';
import TopicsAccordion from '../../common-components/topics-accordion/topics-accordion.vue';
import Helptopics from '../../../services/api/helpTopics';
import SelfCareHeading from '@/components/common-components/selfcare-heading/selfcare-heading.vue';
import { mapState, mapGetters } from 'vuex';
import GetInitData from '@/services/api/HistoryModule/getInitData';
import { getLang, getHelpTopicLength, getLanguage } from '../../../utilities/helperFunctions';

@Component({
  name: 'SelfcareRaiseComplaint',
  components: {
    SelfCareHeading,
    SelfRaiseTabHeading,
    TopicsAccordion,
  },
  computed: {
    ...mapState(['raiseScreenTitle', 'mainCategoryName', 'mainCategoryID']),
    ...mapGetters(['getMode']),
  },
})
export default class SelfcareRaiseComplaint extends Vue {
  sectionHeading: string = 'Choose a category you need help with';
  iconImages: any[] = [];
  bannerImage = {
    src: require('../../../assets/images/selfcare-raise/group-8.png'),
    alt: 'raisecomplaintBanner',
  };
  getCategoryList = [];
  /* slider variables */
  imagesResponse = [];
  bannerImageURL = [];
  delayTime: number = null;
  tab = 0;
  selectedCat: string = '';
  raiseScreenTitle!: string;
  imageDisplay: boolean = false;
  serviceBanner = [];
  /* search box */
  searchloading: boolean = false;
  searchSelect: string = null;
  getHelpTopicsTitles = [];
  filterSearch = null;
  helpTopicCount = null;

  get lang() {
    return this.$store.state.lang;
  }

  get mode() {
    return this.$store.state.mode;
  }

  customHelpTopicFilter(item, queryText, itemText) {
    console.log(item, queryText, itemText);
    const textOne = item.content.title.toLowerCase();
    const textTwo = item.tags.toLowerCase();
    const searchText = queryText.toLowerCase();

    return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
  }

  @Watch('filterSearch')
  helpSearchList(value: any) {
    if (value && value.length >= 3) {
      this.getFilterSearchResult(value);
    }
  }

  /* methods */
  getAllCategory() {
    let categoryInfo = {
      language: getLang(this.lang),
    };

    GetCategoryListing.getAllMainCategory(categoryInfo).then(response => {
      if (response.status === 200) {
        let getCategoryList = response.data;
        let newName = ' ';
        for (let i = 0; i < getCategoryList.length; i++) {
          newName = getCategoryList[i].name ? getCategoryList[i].name.split(' ').join('-') : '';
          this.iconImages.push(newName);
          this.getCategoryList.push(getCategoryList[i]);
        }
      }
    });
  }

  getFilterSearchResult(search) {
    let lang = getLanguage(this.lang);
    let searchValue = {
      searchText: search,
      filter: null,
      language: lang,
    };
    Helptopics.searchHelpTopics(searchValue).then(response => {
      let resultset = response.data;
      this.getHelpTopicsTitles = [];
      for (let i = 0; i < resultset.length; i++) {
        this.getHelpTopicsTitles.push(resultset[i]);
      }
    });
  }

  /* navigate to sub category pages */
  async navigate(cardName: string, cardID: any, cardIndex: number) {
    this.$store.commit('setSource', 'SELFCARE');
    store.commit('CLEAR_CATEGORYNAME');
    let catName = cardName;
    let catNameUrl = cardName;
    catNameUrl = catNameUrl
      .toLowerCase()
      .split(' ')
      .join('-');
    this.selectedCat = catName;

    let mainCatgoryInfo = {
      mainCategoryName: catName,
      mainCategoryID: cardID,
    };
    store.commit('setmainCategoryInfo', mainCatgoryInfo);
    store.commit('setraiseTitle', catName);

    if (store.state.validMainCategoryIds.includes(store.state.mainCategoryInfo.mainCategoryID)) {
      if (!store.state.filterData || store.state.filterData.length == 0) {
        const initDataResponse = await GetInitData.getInitData({});
        if (
          !(
            initDataResponse.data.rs !== 'S' ||
            !initDataResponse.data.payload ||
            !initDataResponse.data.payload.filterData
          )
        ) {
          try {
            store.commit('setFilterData', JSON.parse(initDataResponse.data.payload.filterData));
          } catch (e) {
            store.commit('setFilterData', []);
            console.error(e);
          }
        } else {
          store.commit('setFilterData', []);
        }
      }
    }

    let value = {
      key: 'categoryId',
      name: catName,
      route: this.$route.name,
    };
    store.commit('RAISECOMPLAINTARRAY', value);

    console.log(store.state.raiseComplaintCatVal);

    store.commit('setProductRelated', this.getCategoryList[cardIndex].productRelated);
    if (
      this.getCategoryList[cardIndex].subCategoryPresent &&
      this.getCategoryList[cardIndex].productRelated
    ) {
      this.$router.push({
        name: 'ProductListing',
        params: { url: catNameUrl, id: cardID, name: catName },
      });
    } else if (
      this.getCategoryList[cardIndex].subCategoryPresent &&
      !this.getCategoryList[cardIndex].productRelated
    ) {
      this.$router.push({ name: 'SubCategory', params: { url: catNameUrl, name: catName } });
    } else {
      //Here Directly User is being Redirected To Raise Complaint
      let attachment = this.getCategoryList[cardIndex].subCategories[0].attachmentRequired;
      let attachementvalue = {
        attachmentRequired: attachment,
        topicName: catName,
      };
      store.commit('setAttachment', attachementvalue);

      getHelpTopicLength(data => {
        this.helpTopicCount = data.length;
        if (!this.helpTopicCount) {
          this.$router.push({ name: 'HelpRaiseComplaint' });
        } else {
          this.$router.push({
            name: 'HelpTopics',
            params: { filterVisible: 'false', isHelpTopicData: 'true' },
          });
        }
      });
    }
    //Google Analytics
    this.$gtag.event('click', {
      event_category: `SelfCare`,
      event_label: `Clicked ${cardName}`,
    });
  }

  navigateToTab(tabName: string) {
    if (tabName === 'View Status') {
      this.$router.push({ name: 'ViewStatus' });
    } else if (tabName === 'Raise Complaint') {
      this.$router.push({ name: 'SelfcareRaiseComplaint' });
    }
  }

  /* banner images */
  bannerImages() {
    GetCategoryListing.bannerImage().then(response => {
      let bannerSrc = '';
      this.imagesResponse = response.data;
      this.delayTime = response.data.delayTime;

      for (let i = 1; i <= 10; i++) {
        let keyName = 'image' + i;
        if (this.imagesResponse[keyName]) {
          this.bannerImageURL.push(this.imagesResponse[keyName]);
        }
      }
      if (this.bannerImageURL.length == 0) {
        this.bannerImageURL = null;
      }
      //concatenation of bannerapi url and servicedown api
      if (!this.bannerImageURL) {
        this.bannerImageURL = this.serviceBanner;
      } else {
        this.bannerImageURL = this.serviceBanner.concat(this.bannerImageURL);
      }
    });
  }

  serviceDownBanner() {
    let catID = {
      categories: null,
      sub_categories_1: null,
      from_date_time_lte: new Date().toISOString(),
      to_date_time_gte: new Date().toISOString(),
    };
    Helptopics.serviceDownImage(catID).then(response => {
      let serviceBanner = response.data;
      for (let i = 0; i < serviceBanner.length; i++) {
        if (
          serviceBanner[i].content[0].image_desktop.includes('png') ||
          serviceBanner[i].content[0].image_desktop.includes('jpg') ||
          serviceBanner[i].content[0].image_desktop.includes('jpeg')
        ) {
          this.serviceBanner.push(serviceBanner[i].content[0].image_desktop);
        }
      }
      this.getAllCategory();
      this.bannerImages();
    });
  }

  navigateToCategory() {
    this.$router.push({ name: 'CategoryList' });
  }

  navigateToTopicList(filterText: string, event: string) {
    if (event == 'enter') {
      this.$router.push({
        name: 'HelpTopics',
        params: { url: 'search', filterTopicName: null, backVisible: 'true' },
      });
    } else if (event == 'click') {
      store.commit('setFilterText', filterText);
      this.$router.push({
        name: 'HelpTopics',
        params: {
          url: 'search',
          filterTopicName: filterText,
          backVisible: 'true',
        },
      });
    }
  }

  @Watch('lang')
  selectedLang() {
    this.serviceDownBanner();
    this.getCategoryList = [];
  }

  /* mounted function */
  mounted() {
    store.commit('CLEAR_MAINCATEGORYINFO');
    store.commit('CLEAR_PRODUCTID');
    this.serviceDownBanner();
    store.commit('clearAttachment');
    this.$store.commit('setKnowledgeCenter',false)
  }
}
